import actions from '../../actionTypes';

export default workflow => {
  return {
    type: actions.SET_CURRENT_WORKFLOW,
    workflow
  };
};



// WEBPACK FOOTER //
// ./src/reducers/workflows/actions/setCurrentWorkflow.js